import React from 'react';
import {Field} from 'formik';
import {TextField} from 'formik-mui';
import Card from '@mui/material/Card';

export default function TransferEntryOneUpdate(props) {
  return (
    <Card className={'box-shadow'} sx={{p: 4}}>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Ownership'}
             name={`ownership`} disabled
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Accession No.'}
             name={`accession_no`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Classification'}
             name={`classification`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Object Type'}
             name={`object_type`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Object Name'}
             name={`object_name`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Sub Group'}
             name={`sub_group`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Materials'}
             name={`material`} disabled
             sx={{mt: 1.5}}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}